import useSysConfig from "./useSysConfig"
import { getResourceUrl } from "@/lib/utils"

export function useResourceUrl(resourcePath: string | undefined) {
  const config = useSysConfig()

  if (!resourcePath) return ""

  return getResourceUrl(resourcePath, config.serverRoot)
}
